import React, { Component, PropTypes } from 'react';
import { Link } from 'react-router';
import moment from 'moment';
import classnames from 'classnames';
import truncate from 'lodash/truncate';
import Money from 'common/components/money';
import Icon from 'common/components/svg_icon';
import Thumbnail from 'common/components/thumbnail';
import StarRating from 'common/components/star_rating';
import ProjectLink from 'common/containers/project_link';
import RevisionDisclosures from 'entries/containers/revision_disclosures';
import Menu from 'entries/containers/actions_menu';
import Filter from 'common/filter/containers';
import AwardButton from 'entries/containers/award_button';
import { TYPE_STRING } from 'common/filter/constants';
import { ENTRIES_RESOURCE_NAME } from 'entries/constants';

export default class ImageNameTile extends Component {
  constructor(props) {
    super(props);

    this.state = { menuOpen: false };

    this.handleDelete = this.handleDelete.bind(this);
    this.handleRate = this.handleRate.bind(this);
  }

  handleDelete(e) {
    const { item, onDelete } = this.props;

    e.preventDefault();
    e.stopPropagation();

    onDelete(item);
  }

  handleRate(rating) {
    const { item, onRate } = this.props;
    onRate(item, rating);
  }

  renderThumbnail() {
    const { menuOpen } = this.state;
    const {
      item, entryType, canDelete, canViewNewTag, canViewRating, canViewAwardValue, canViewTipValue,
      canViewOfferValue
    } = this.props;
    const revision = item.revisions[0];
    const thumbClasses = classnames('tile entry-thumbnail', {
      withdrawn: item.withdrawn,
      stacked: item.revisions.length > 1,
    });
    /* elimination is a form of scoring, so just show the "eliminated" message if user
       can also see the score */
    const showEliminatedMsg = item.eliminated && canViewRating;

    return (
      <Thumbnail className={thumbClasses} image={entryType === 'name'? null : revision.thumbnails[0]}>

        { entryType === "name" && <div className="revision-name">{ revision.name }</div> }

        <div className={classnames('tile-tools', { '--menu-open': menuOpen })}>
          <Menu entry={item} onToggle={o => this.setState({ menuOpen: o })} />

          { canDelete &&
          <button className="btn btn-icon-only btn-remove" onClick={this.handleDelete}>
            <Icon className={classnames('svg-icon inline', 'svg-icon-lg')} icon="trash" />
          </button> }
        </div>

        { revision.new && canViewNewTag &&
        <div className="flag new">
          <div>
            <span>New!</span>
          </div>
        </div> }

        { (item.withdrawn || showEliminatedMsg) &&
        <div className={classnames("message", { "double": item.withdrawn && showEliminatedMsg })}>
          { item.withdrawn && <div>withdrawn</div> }

          { item.withdrawn && showEliminatedMsg && <div>and</div> }

          { showEliminatedMsg && <div>eliminated</div> }
        </div> }

        { item.winner &&
        <div className={classnames('flag winner', { 'with-value': canViewAwardValue })}>
          <div>
            <span>Winner</span>
            { canViewAwardValue && <Money className="value" value={item.award_value} /> }
          </div>
        </div> }

        { item.runnerup && !item.winner &&
        <div className={classnames('flag winner', { 'with-value': canViewAwardValue })}>
          <div>
            <span>Finalist</span>
            { canViewAwardValue && <Money className="value" value={item.award_value} /> }
          </div>
        </div> }

        { !!parseFloat(item.tip_value) && canViewTipValue &&
        <div className="flag tipped with-value">
          <div>
            <span>Tipped</span>
            <Money className="value" value={item.tip_value} />
          </div>
        </div> }

        { !!parseFloat(item.offer_value) && canViewOfferValue &&
        <div className="flag tipped with-value">
          <div>
            <span>Offered</span>
            <Money className="value" value={item.offer_value} />
          </div>
        </div> }

        <AwardButton entry={item} />
      </Thumbnail>
    );
  }

  render() {
    const {
      item, project, grouped, viewType, canViewRating, canRate, canViewDescription,
      canViewAssetPrice, canFilterByCreative
    } = this.props;
    const revision = item.revisions[0];
    const truncatedUsername = truncate(item.author_username, { length: 25 });

    return (
      <div className="column column-block entry">
        <div className="entry-tile">
          <div className="tile-left">
            <ProjectLink project={project} append={`entry/${item.id}/`}
                search={`?revision=${revision.id}`}>
              { this.renderThumbnail() }
            </ProjectLink>

            { canViewRating &&
            <StarRating min={1} readonly={!canRate} initialRate={revision.score || 0}
              onChange={this.handleRate} extraClasses='lg' /> }
          </div>

          <div className="tile-right">
            <p className="revision-author">
              <span className="entry-number">
                #{ grouped ? item.entry_number : revision.revision_number }
              </span> by {' '}

              { canFilterByCreative?
              <Filter field="entry_author_username" type={TYPE_STRING} string={item.author_username}
                stringLabel={truncatedUsername} resourceName={ENTRIES_RESOURCE_NAME} /> :
              <Link to={`/users/${item.author_username}/`} target="_blank">
                { truncatedUsername }
              </Link> }{' '}

              <span className="revision-time">{ moment(revision.created_at).fromNow() }</span>
            </p>

            { canViewDescription && viewType === "list" &&
            <div className="revision-description">
              <h4>Description:</h4>
              <p>{ revision.description }</p>
            </div> }

            { viewType === "list" &&
            <RevisionDisclosures entry={item} revision={revision}
              canViewAssetPrice={canViewAssetPrice} /> }
          </div>
          <div className="clearfix" />
        </div>
      </div>
    );
  }
}

ImageNameTile.propTypes = {
  item: PropTypes.object.isRequired,
  project: PropTypes.object.isRequired,
  viewType: PropTypes.string.isRequired,
  entryType: PropTypes.string.isRequired,
  grouped: PropTypes.bool,
  canDelete: PropTypes.bool.isRequired,
  canViewNewTag: PropTypes.bool.isRequired,
  canViewRating: PropTypes.bool.isRequired,
  canViewAwardValue: PropTypes.bool.isRequired,
  canViewTipValue: PropTypes.bool.isRequired,
  canViewOfferValue: PropTypes.bool.isRequired,
  canRate: PropTypes.bool.isRequired,
  canViewDescription: PropTypes.bool.isRequired,
  canViewAssetPrice: PropTypes.bool.isRequired,
  canFilterByCreative: PropTypes.bool.isRequired,
  onDelete: PropTypes.func.isRequired,
  onRate: PropTypes.func.isRequired,
};



// WEBPACK FOOTER //
// ./entries/components/image_name_tile.jsx